import { apiClient } from "@/api/api-client.ts";
import createBaseService from "@/api/base-service.ts";
import type {
	CreateInvoicePrintTemplateData,
	InvoicePrintTemplate,
	PrintTemplateSettings,
	UpdateInvoicePrintTemplateData,
} from "../../types/invoice-print-template";

const invoicePrintTemplateService = {
	...createBaseService<InvoicePrintTemplate, CreateInvoicePrintTemplateData, UpdateInvoicePrintTemplateData>("/invoice-print-templates"),

	async list(): Promise<{ data: InvoicePrintTemplate[]; defaults: PrintTemplateSettings }> {
		const response = await apiClient.get<{ data: InvoicePrintTemplate[]; defaults: PrintTemplateSettings }>("/invoice-print-templates");
		return response.data;
	},

	async activate(id: string): Promise<InvoicePrintTemplate> {
		const response = await apiClient.post<{ data: InvoicePrintTemplate }>(`/invoice-print-templates/${id}/activate`);
		return response.data.data;
	},

	async uploadBackground(id: string, file: File): Promise<InvoicePrintTemplate> {
		const formData = new FormData();
		formData.append("background", file);
		const response = await apiClient.post<{ data: InvoicePrintTemplate }>(`/invoice-print-templates/${id}/background`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		return response.data.data;
	},
};

export default invoicePrintTemplateService;
